import { Route, Routes} from "react-router-dom";
import ErrorBoundary from "../../components/Utils/ErrorBoundary";

import withName from "../../hoc/withName";
import PriceList from "../../components/PriceList/PriceList";
import BillingClientParams from "../../components/BillingClientParams/BillingClientParams.js";
import BillingClientParamsForm from "../../components/BillingClientParams/BillingClientParamsForm";
import BillingDocuments from "../../components/BillingDocuments/BillingDocuments.js";
import Personal from "../Personal/Personal.js";
import { AuthenticatorContext } from "../../contexts/AuthenticatorContext.js";
import { useContext,useEffect, useState } from "react";
import { RestAPI } from "@aws-amplify/api-rest";


const Billing = () => {
    const { refreshUser, signOut, userInfo } = useContext(AuthenticatorContext);
    const [usuarioInfo, setInfo] = useState({ data: [], isLoaded: false });
    const [personalInfo, setPersonalInfo] = useState({ data: [], isLoaded: false });
    useEffect(() => {
        RestAPI.get("apiAdminDropControl", "/personal")
            .then(res => {
                const json = JSON.parse(JSON.stringify(res));
                setInfo({ isLoaded: true, data: json });
            })
            .catch(err => console.error(err));
    }, []);
    useEffect(() => {
        const newPersonalInfo = { ...usuarioInfo.data };

        if (userInfo && newPersonalInfo) {
            if (userInfo.name) {
                newPersonalInfo.nombre = userInfo.name;
            }
            if (userInfo.family_name
        && userInfo.family_name !== `${newPersonalInfo.apellido_paterno || ""} ${newPersonalInfo.apellido_materno || ""}`) {
                const idx = userInfo.family_name.indexOf(" ");
                const splits = idx > -1 ? [userInfo.family_name.slice(0, idx), userInfo.family_name.slice(idx + 1)]
                    : [userInfo.family_name, ""];
                newPersonalInfo.apellido_paterno = splits[0] || "";
                newPersonalInfo.apellido_materno = splits[1] || "";
            }
        }

        setPersonalInfo({ isLoaded: usuarioInfo.isLoaded, data: newPersonalInfo });
    }, [usuarioInfo, userInfo]);
    return (
        <>
            <ErrorBoundary name="Billing" resetOnChange={false}>
                <Routes>
                    <Route path="/priceList" element={<PriceList />} />
                    <Route path="/personal" element={<Personal info={personalInfo} refreshUser={refreshUser} setInfo={setInfo} />} />
                    <Route path="/clientparams" element={<BillingClientParams />} />
                    <Route path="/clientparams/:id" element={<BillingClientParamsForm />} />
                    <Route path="/documents/:hub/:date" element={<BillingDocuments />} />
                </Routes>
            </ErrorBoundary>
        </>
    );
};
export default withName(Billing, "BillingPage");
